<div class="ion-text-center player-list">
    <div
      class="teamfullname"
      [ngStyle]="{
        backgroundColor: sideColors[sideName === 'side1' ? 0 : 1],
      }" 
      [style.height.px]="rowHeight * 1 - 15"
      [style.font-size.px]="rowHeight / 4"
    >
    <span>{{ getTeam(sideNumber)?.name }}</span>
    </div>
  </div>